import {
  ArrowLeft,
  ArrowRight,
  Ban,
  BedDouble,
  Bell,
  Brain,
  Calendar,
  CalendarClock,
  Camera,
  CarFront,
  ChartColumnIncreasing,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CircleCheckBig,
  CircleGauge,
  CircleHelp,
  Clock,
  Coffee,
  Copy,
  Dot,
  Download,
  ExternalLink,
  Eye,
  EyeClosed,
  Fan,
  Flame,
  Flashlight,
  FlashlightOff,
  Gift,
  HandCoins,
  Heater,
  House,
  Info,
  LeafyGreen,
  Lightbulb,
  LightbulbOff,
  LoaderCircle,
  Lock,
  Mail,
  Maximize2,
  Menu,
  MessageSquare,
  Microwave,
  Minimize2,
  Minus,
  Moon,
  OctagonAlert,
  Package,
  PhoneIcon,
  Plus,
  PowerOff,
  ReceiptPoundSterling,
  RotateCcw,
  SearchIcon,
  Send,
  Shield,
  ShowerHead,
  SlidersHorizontal,
  Star,
  Sun,
  Thermometer,
  Ticket,
  TimerReset,
  TriangleAlert,
  UserRound,
  Wallet,
  WashingMachine,
  Wind,
  Wrench,
  X,
  Zap,
  ZapOff,
} from "lucide-vue-next"
import PoundCircle from "@/components/ui/icons/PoundCircle.vue"

export const iconsMap = {
  Info: Info,
  Error: TriangleAlert,
  Warning: OctagonAlert,
  CircleCheck: CircleCheckBig,
  Gas: Flame,
  Electricity: Zap,
  Question: CircleHelp,
  Camera: Camera,
  ArrowLeft: ArrowLeft,
  ArrowRight: ArrowRight,
  Calendar: Calendar,
  OpenBrowser: ExternalLink,
  Close: X,
  Check: Check,
  Plus: Plus,
  Download: Download,
  Dot: Dot,
  ChevronLeft: ChevronLeft,
  ChevronDown: ChevronDown,
  ChevronRight: ChevronRight,
  ChevronUp: ChevronUp,
  Visible: Eye,
  Hidden: EyeClosed,
  Day: Sun,
  Night: Moon,
  Tip: Lightbulb,
  Wallet: Wallet,
  Renew: CalendarClock,
  Meter: CircleGauge,
  Bell: Bell,
  Search: SearchIcon,
  Phone: PhoneIcon,
  Message: MessageSquare,
  Spinner: LoaderCircle,
  Email: Send,
  Minus: Minus,
  More: Menu,
  Home: House,
  Readings: CircleGauge,
  Usage: ChartColumnIncreasing,
  Pounds: PoundCircle,
  Filter: SlidersHorizontal,
  Spanner: Wrench,
  Maximise: Maximize2,
  Minimise: Minimize2,
  Comms: Mail,
  Profile: UserRound,
  Reload: RotateCcw,
  Heater,
  ZapOff,
  Microwave,
  LightbulbOff,
  Thermometer,
  TimerReset,
  Wind,
  BedDouble,
  Coffee,
  Fan,
  ShowerHead,
  PowerOff,
  WashingMachine,
  Flashlight,
  FlashlightOff,
  CarFront,
  Clock,
  ReceiptPoundSterling,
  LeafyGreen,
  Brain,
  Copy,
  Ban,
  Shield,
  Star,
  Lock,
  HandCoins,
  Ticket,
  Gift,
  Package,
} as const

export type IconType = keyof typeof iconsMap
